import React, { useEffect, useState } from "react";
import "./masterPrompt.scss";
import MasterPromptList from "./MasterPromptList";
import PromptContent from "./PromptContent";
import HistoryTable from "./HistoryTable";
import PublishPrompt from "./PublishPrompt";
import { useValidationManager } from "../../../../../hooks/useValidation";
import { VirtualLibrarianService } from "../../../../../services/VirtualLibrarianService";
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { useHookstate } from "@hookstate/core";

function getAllowedGuardrails(guardrails) {
  switch (guardrails) {
    case "System Prompt Header":
      return false;
    // case "Example Question and Response":
    //   return false;
    case "Customizations Header":
      return false;
    default:
      return true;
  }
}

export default function MasterPrompt({ guardrails, organization }) {
  const validationManager = useValidationManager(false, ["GUARDRAIL"]);
  const [orderedGuardrails, setOrderedGuardrails] = useState([]);
  const [selectedGuardrail, setSelectedGuardrail] = useState(undefined);
  const [selectedView, setSelectedView] = useState("prompt");
  const authStore = useHookstate(globalAuthStateStore);
  const vlService = React.useMemo(
    () => new VirtualLibrarianService(authStore),
    [authStore]
  );

  useEffect(() => {
    if (orderedGuardrails.length === 0) {
      const reorderedGuardrails =
        guardrails
          ?.sort((a, b) => a.order - b.order)
          .filter((guardrail) => getAllowedGuardrails(guardrail.promptTitle)) ??
        [];
      setOrderedGuardrails(reorderedGuardrails);
      setSelectedGuardrail(reorderedGuardrails[0]);
    }
  }, [guardrails]);

  useEffect(() => {
    if (orderedGuardrails.length === 0 && selectedGuardrail === undefined) {
      setSelectedGuardrail(orderedGuardrails[0]);
    }
  }, [orderedGuardrails, setSelectedGuardrail]);

  const handlePublishButton = (guardrail) => {
    setSelectedView("publish");
    const updatedGuardrails = orderedGuardrails.map((orderedGuardrail) => {
      if (orderedGuardrail.id === guardrail.id) {
        return guardrail;
      }
      return orderedGuardrail;
    });
    setOrderedGuardrails(updatedGuardrails);
    setSelectedGuardrail(guardrail);
  };

  const handlePublish = async () => {
    const result = await vlService.saveGuardrail(
      selectedGuardrail.id,
      selectedGuardrail
    );

    if (result.Success && result.Data) {
      console.log("Guardrail saved successfully:", result);
      setSelectedView("prompt");
    }
  };

  return (
    <>
      {selectedView === "prompt" && (
        <div className="master-prompt">
          <MasterPromptList
            orderedGuardrails={orderedGuardrails}
            selectedGuardrail={selectedGuardrail}
            setSelectedGuardrail={setSelectedGuardrail}
          />
          <PromptContent
            selectedGuardrail={selectedGuardrail}
            organization={organization}
            setSelectedView={() => setSelectedView("history")}
            handlePublishButton={handlePublishButton}
          />
        </div>
      )}
      {selectedView === "history" && (
        <HistoryTable
          selectedGuardrail={selectedGuardrail}
          setSelectedView={() => setSelectedView("prompt")}
        />
      )}
      {selectedView === "publish" && (
        <PublishPrompt
          orderedGuardrails={orderedGuardrails}
          setSelectedView={() => setSelectedView("prompt")}
          handlePublish={() => handlePublish()}
        />
      )}
    </>
  );
}
